import React from 'react';

import CashSummary from './CashSummary';
import { CODSalary } from './CODSalary';
import CreditCollection from './CreditCollection';
import NeftSummary from './NeftSummary';
import SwipeSummary from './SwipeSummary';
import TempCredit from './TempCredit';
import WalletsSummary from './WalletsSummary';

const CollectionSummary = (props) => {
  const { syncCODCollectionData, isViewMode } = props;

  const updateTotalSummary = () => {
    syncCODCollectionData(props.match.params.duty, props.match.params.staff);
  };

  return (
    <>
      <CashSummary
        {...props}
        onDataChange={updateTotalSummary}
        isViewMode={isViewMode}
      />
      <WalletsSummary
        {...props}
        collectionData={props.collectionData}
        onDataChange={updateTotalSummary}
        isViewMode={isViewMode}
      />
      <SwipeSummary
        {...props}
        collectionData={props.collectionData}
        onDataChange={updateTotalSummary}
        isViewMode={isViewMode}
      />
      <NeftSummary
        {...props}
        collectionData={props.collectionData}
        onDataChange={updateTotalSummary}
        isViewMode={isViewMode}
      />
      <CreditCollection
        {...props}
        onDataChange={updateTotalSummary}
        isViewMode={isViewMode}
      />
      <CODSalary
        {...props}
        onDataChange={updateTotalSummary}
        isViewMode={isViewMode}
      />
      <TempCredit
        {...props}
        onDataChange={updateTotalSummary}
        isViewMode={isViewMode}
      />
    </>
  );
};

export { CollectionSummary };
